/**
 * Devices — the lines of a terminal, which the contact console prints as
 * the form changes. The frames themselves (browser, terminal) are the
 * server's (templates/site/components/_ui.html.twig).
 *
 * @module components/devices
 */

import { html } from '../lib/html.js';

/**
 * @typedef {['cmd' | 'out' | 'hi' | 'note' | 'err', string]} TerminalLine
 * A line of a terminal: a command, its output, a highlight, a comment or
 * an error.
 */

/**
 * The body of a terminal: its lines and the blinking caret.
 *
 * @param {TerminalLine[]} lines
 * @returns {import('../lib/html.js').Markup}
 */
export function terminalLines(lines) {
    const body = lines.map(([kind, text]) => html`<span class="terminal__line terminal__line--${kind}">${text}</span>`);

    // The body is preformatted: the newlines are passed as values, which
    // the template keeps.
    const caret = html`<span class="terminal__caret" aria-hidden="true"></span>`;

    return html`${body.flatMap((line, index) => (index ? ['\n', line] : [line]))}${'\n'}${caret}`;
}
